import { AnalyticsService } from '@alison/analytics/client';
import { createContext, type ReactNode, useContext, useRef } from 'react';

const TooltipTrackingContext = createContext<(tile: string) => void>(() => {});

export function TooltipTrackingProvider({ children }: { children: ReactNode }): ReactNode {
  const seenTiles = useRef(new Set<string>());
  const trackTooltip = (tile: string): void => {
    if (seenTiles.current.has(tile)) return;
    seenTiles.current.add(tile);
    AnalyticsService.track('Dashboard - View Tooltip', { tile });
  };
  return (
    <TooltipTrackingContext.Provider value={trackTooltip}>
      {children}
    </TooltipTrackingContext.Provider>
  );
}

export function useTrackTooltip(): (tile: string) => void {
  return useContext(TooltipTrackingContext);
}
